import React from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Input } from './Input';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
  disabled = false
}) => {
  const handleClear = () => {
    onChange('');
  };

  return (
    <div className={`w-full sm:w-72 relative ${className}`}>
      <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="!pl-10 !pr-10 !py-2.5 !text-sm !text-[13px]"
      />
      {value && !disabled && (
        <button
          onClick={handleClear}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 rounded-full bg-gray-300 hover:bg-gray-400 flex items-center justify-center transition-colors"
          aria-label="Clear search"
        >
          <XMarkIcon className="h-3 w-3 text-gray-600" />
        </button>
      )}
    </div>
  );
}; 